import { Service } from '@roc/feature-app-core';

const url = {
  UPLOAD_PROPERTY_DOCUMENT_DATA_FILE: '/api/v1/doc-review/property-document-data/upload',
  DOWNLOAD_PROPERTY_DOCUMENT_DATA_FILE: '/api/v1/doc-review/property-document-data/download',
  GET_PROPERTY_DOCUMENT_DATA_FILE: '/api/v1/doc-review/property-document-data/getPropertyDocumentData',
};

export class PropertyDocumentDataService extends Service {
  upload(file: File, loanId: number, propertyId: number, taskId: number, type: string) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('loanId', String(loanId));
    formData.append('propertyId', String(propertyId));
    formData.append('taskId', String(taskId));
    formData.append('type', type);
    return this.post(url.UPLOAD_PROPERTY_DOCUMENT_DATA_FILE, formData);
  }

  download(propertyDocumentDataId: number) {
    return this.get(
      url.DOWNLOAD_PROPERTY_DOCUMENT_DATA_FILE,
      { propertyDocumentDataId },
      { responseType: 'arraybuffer' }
    );
  }

  fetch(loanId: number, propertyId: number, type: string) {
    return this.get(url.GET_PROPERTY_DOCUMENT_DATA_FILE, { loanId, propertyId, type });
  }
}
